import { STORAGE_KEYS } from '../constants/app.constants';
import { DashboardUser } from '../models/user.model';

export class LocalStorageUtils {
  static saveUserData(data: DashboardUser, isCompany: boolean = false): void {
    const key = isCompany ? STORAGE_KEYS.COMPANY_USER_DATA : STORAGE_KEYS.USER_DATA;
    localStorage.setItem(key, JSON.stringify(data));
  }

  static getUserData(isCompany: boolean = false): DashboardUser | null {
    const key = isCompany ? STORAGE_KEYS.COMPANY_USER_DATA : STORAGE_KEYS.USER_DATA;
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }

  static removeUserData(isCompany: boolean = false): void {
    const key = isCompany ? STORAGE_KEYS.COMPANY_USER_DATA : STORAGE_KEYS.USER_DATA;
    localStorage.removeItem(key);
  }
}

export class UserUtils {
  static getFullName(firstName: string, lastName: string): string {
    return `${firstName} ${lastName}`.trim();
  }

  static hasValidName(firstName: string, lastName: string): boolean {
    return !!(firstName && lastName);
  }
}